// Enrollment status reference — mirrors MembersList/enums/subscriptionStatuses.js.
// `tone` maps 1:1 to a StatusChip variant: StatusChip[Success|Error|Alert|Info|Default].
// See ClickUp 868jxkz4p §3. Built from the caller's `t` so the labels follow the
// active language.
export const getEnrollmentStatuses = (t) => [
  { id: "pending", label: t("enrollmentStatuses.pending"), tone: "alert" },
  { id: "awaiting_community", label: t("enrollmentStatuses.awaitingCommunity"), tone: "info" },
  { id: "active", label: t("enrollmentStatuses.active"), tone: "success" },
  { id: "split_only", label: t("enrollmentStatuses.splitOnly"), tone: "info" },
  { id: "rejected", label: t("enrollmentStatuses.rejected"), tone: "error" },
  { id: "declined", label: t("enrollmentStatuses.declined"), tone: "error" },
  { id: "ended", label: t("enrollmentStatuses.ended"), tone: "default" },
];

export const getEnrollmentStatusLabel = (t) =>
  getEnrollmentStatuses(t).reduce(
    (acc, status) => ({ ...acc, [status.id]: status.label }),
    {}
  );

export const ENROLLMENT_STATUS_TONE = {
  pending: "alert",
  awaiting_community: "info",
  active: "success",
  split_only: "info",
  rejected: "error",
  declined: "error",
  ended: "default",
};

// StatusChip variant component keyed by tone, e.g. STATUS_CHIP_VARIANT["success"] → "Success".
export const STATUS_CHIP_VARIANT = {
  success: "Success",
  error: "Error",
  alert: "Alert",
  info: "Info",
  default: "Default",
};
